import Paper from '@material-ui/core/Paper'
import React from 'react'
import { Typography, withStyles, withWidth } from '@material-ui/core'
import PyramidOfHateSegment, { DRAG_NAMES } from './PyramidOfHateSegment'
import SymbolsOfHateSegment, { MEMORY } from './SymbolsOfHateSegment'
import PictureCutSegment, { POINTS_TO_QUESTIONS } from './PictureCutSegment'
import CircleOfHateSegment, { CIRCLE_OF_HATE } from './CircleOfHateSegment'
import CommentsForArticle from '../comments/CommentsForArticle'
import ArticleReliability, { ARTICLE_RELIABILITY } from './ArticleReliability'
import GroundingSubsegment, { GROUNDING } from './GroundingSubsegment'
import animateScrollTo from 'animated-scroll-to'
import * as ReactDOM from 'react-dom'
import BurdenTreeSegment, { BURDEN_TREE } from './BurdenTreeSegment'
import ActiveListeningSegment, { ACTIVE_LISTENING } from './ActiveListeningSegment'
import ImagePoints from './ImagePoints'
import HowToUse from '../HowToUse'
import ContentDrawer from '../ContentDrawer'
import SVGInline from 'react-svg-inline/src'
import arrowBlack from '../../media/article_list/arrow_black.svg'
import scrollBlack from '../../media/article_list/scroll_black.svg'
import activityBlack from '../../media/article_list/activity_white_notext.svg'
import lessonBlack from '../../media/article_list/lesson_white_notext.svg'
import infoBlack from '../../media/article_list/info_white_notext.svg'
import reflectionBlack from '../../media/article_list/reflection_white_notext.svg'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Button from '@material-ui/core/Button'
import SvgArrowRed from '../icons/arrow_red'
import DosAndDontsQuiz from './DosAndDonts'

export const POINT_MAP = 'POINT_MAP'
export const CASE_STUDY = 'CASE_STUDY'
export const MIND_MAP = 'MIND_MAP'
export const LESSON_ACTIVITY = 'LESSON_ACTIVITY'
export const LESSON_LESSON = 'LESSON_LESSON'
export const LESSON_REFLECTION = 'LESSON_REFLECTION'

const styles = theme => ({
  pointsBackground: {
    margin: '0 auto',
  },
  paper: {
    // position: 'absolute',
    // width: theme.spacing.unit * 50,
    // backgroundColor: theme.palette.background.paper,
    // boxShadow: theme.shadows[5],
    // padding: theme.spacing.unit * 4,
    // outline: 'none',
    // top: '50%',
    // left: '50%',
    // transform: `translate(-50%, -50%)`,
    textAlign: 'justify'

  },
  lessonContent: {
    margin: '0 auto',
    textAlign: 'justify',
    // maxWidth: 1240,
    width: '100%',
    padding: '20px 10px',
  },
  lessonBefore: {
    margin: '5px auto',
    textAlign: 'justify',
    padding: '20px 20px',
    width: '100%',
    '& hr': {
      backgroundColor: 'black',
      height: 5,
      width: 150,
      margin: '30px 0px'
    }

  },
  lessonAfter: {
    margin: '5px auto',
    textAlign: 'justify',
    padding: '20px 20px',
    width: '100%'
  },
  inSituTitle: {
    maxWidth: 1000,
    backgroundColor: '#CA8456',
    textAlign: 'center',
    fontSize: 20,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: 'white',
    margin: '10px auto',
    padding: 10,
  },
  topics: {
    backgroundColor: '#CA8456',
    textTransform: 'uppercase',
    color: 'white',
    width: '100%',
    height: 110,
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0
  },
  helpIcon: {
    display: 'inline-flex',
    color: 'black',
    margin: 10,
  },
  scrollIcon: {
    position: 'absolute',
    right: 60,
    top: 20
  },
  articleTitle: {
    fontWeight: 'bold',
    lineHeight: 1.69,
    fontSize: 29,
    textTransform: 'uppercase',
    marginTop: 10,
  },

  articleTitleBorder: {
    backgroundColor: 'black',
    height: 5,
    width: 150,
    margin: '30px 0px'
  },
  rightText: {
    color: 'black',
    margin: 20,
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'left',
    alignItems: 'center'
  },
  cardLink: {
    maxWidth: 1000,
    display: 'block',
    margin: '10px auto',
    backgroundColor: 'white',
    color: '#d80000',
    borderRadius: 0,
    textDecoration: 'none',
    fontSize: 16,
    fontWeight: 'bold',
  },
  titleHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start'
  },
  activityText: {
    backgroundColor: 'black',
    color: 'white',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex'
  },
  rightTextInner: {
    display: 'inline-flex',
    textTransform: 'uppercase',
    padding: 10,
    fontSize: 21,
    fontWeight: 'bold',
    color: 'white'
  },
  arrowSide: {
    position: 'fixed',
    top: '50%',
    transform: 'translate(-55px)',
    zIndex: 1450,
    backgroundColor: 'white',
    borderRadius: 90,
    left: '50%',
  },
  arrowSideActivity: {
    extend: 'arrowSide',
    left: '90%',
  },
  arrowSideActivityReliability: {
    extend: 'arrowSide',
    left: '50%',
  },
  arrowSideActivityPyramid: {
    extend: 'arrowSide',
    left: '90%',
  },
  drawerPaper: {
    width: '50%',
    alignItems: 'start',
    padding: '40px 80px',
    scrollWidth: 'none',
    '&::-webkit-scrollbar': {
      width: 0,
      height: 0
    }
  },
  drawerPaperActivity: {
    extend: 'drawerPaper',
    width: '90%',
  },
  drawerPaperActivityReliability: {
    extend: 'drawerPaper',
    width: '50%',
  },
  drawerPaperActivityPyramid: {
    extend: 'drawerPaper',
    width: '90%',
  },
})

// function mapFromChildren (children, radius) {
//   let map = { name: 'map', areas: [] }
//   if (!radius) {
//     radius = RADIUS
//   }
//   for (let child of children) {
//     // active listening
//     if (child.item_type === ACTIVE_LISTENING) {
//       map.areas.push({
//         id: child.id,
//         name: child.id,
//         coords: [child.image_x, child.image_y, radius + 5],
//         shape: 'circle',
//         item_type: child.item_type,
//         activity: child.activity,
//         area_type: LESSON_ACTIVITY,
//         content_before: child.f_lesson_content_before,
//         content_after: child.f_lesson_content_after,
//         activity_text: child.f_activity_text,
//         activity_text_after: child.f_activity_text_after,
//         content: child.formatted_content,
//         // preFillColor: 'rgba(0, 205, 255, 0.5)'
//       })
//       continue
//     }
//
//     // case study content
//     if (child.id === 8 || child.only_one_button) {
//       map.areas.push({
//         id: child.id,
//         name: child.id,
//         coords: [child.image_x, child.image_y, radius + 5],
//         item_type: child.item_type,
//         area_type: CASE_STUDY,
//         content: child.formatted_content,
//         shape: 'circle'
//       })
//     } else {
//       map.areas.push({
//         id: child.id,
//         name: child.id,
//         coords: xyToCoorods(child.image_x, child.image_y, 'leftTop', radius),
//         item_type: child.item_type,
//         area_type: CASE_STUDY,
//         content: child.formatted_content,
//       })
//     }
//     // lesson content
//     if (child.item_type !== MARKDOWN) {
//
//       map.areas.push({
//         id: child.id,
//         name: child.id,
//         coords: xyToCoorods(child.image_x, child.image_y, 'rightTop', radius),
//         item_type: child.item_type,
//         activity: child.activity,
//         area_type: LESSON_ACTIVITY,
//         content_before: child.f_lesson_content_before,
//         content_after: child.f_lesson_content_after,
//         activity_text: child.f_activity_text,
//         activity_text_after: child.f_activity_text_after,
//         content: child.formatted_content,
//         // preFillColor: 'rgba(0, 205, 255, 0.5)'
//       })
//       map.areas.push({
//         id: child.id,
//         name: child.id,
//         coords: xyToCoorods(child.image_x, child.image_y, 'leftBottom', radius),
//         item_type: child.item_type,
//         activity: child.activity,
//         area_type: LESSON_LESSON,
//         content_before: child.f_lesson_content_before,
//         content_after: child.f_lesson_content_after,
//         content: child.formatted_content,
//         activity_text: child.f_activity_text,
//         activity_text_after: child.f_activity_text_after,
//         // preFillColor: 'rgba(0, 205, 255, 0.5)'
//       })
//       map.areas.push({
//         id: child.id,
//         name: child.id,
//         coords: xyToCoorods(child.image_x, child.image_y, 'rightBottom', radius),
//         item_type: child.item_type,
//         activity: child.activity,
//         area_type: LESSON_REFLECTION,
//         content_before: child.f_lesson_content_before,
//         content_after: child.f_lesson_content_after,
//         content: child.formatted_content,
//         activity_text: child.f_activity_text,
//         activity_text_after: child.f_activity_text_after,
//         // preFillColor: 'rgba(0, 205, 255, 0.5)'
//       })
//     }
//   }
//   return map
// }
//

export function scrollToTop (node) {
  let before = document.getElementById('lesson_before')
  let activity = document.getElementById('activity_text')
  let dom
  if (before) {
    dom = before
  } else if (activity) {
    dom = activity
  } else {
    dom = ReactDOM.findDOMNode(node)
  }
  let rect = dom.getBoundingClientRect()

  animateScrollTo(rect.top - 64 + window.scrollY)
}

const SubsegmentElement = ({ area }) => {
  let content = ''
  if (area) {
    switch (area.area_type) {
      case 'CASE_STUDY':
        content = area.content
        break
      case LESSON_LESSON:
        content = area.content_before
        break
      case LESSON_REFLECTION:
        content = area.content_after
        break
      default:
        content = null
    }
  }

  let showLink = false

  if (area.item_type === MIND_MAP) {
    showLink = true
  }
  const doAndDontQuiz = Boolean(area.segment_menu & 0x10)
  console.log(doAndDontQuiz, area.segment_menu, area)

  return area ?
    <div className='modal_container'>
      <Typography
        dangerouslySetInnerHTML={{ __html: content }}>
      </Typography>
      {doAndDontQuiz ? <DosAndDontsQuiz/> : ''}

      {area.area_type === LESSON_REFLECTION ?
        <CommentsForArticle key="comments" articleSubsegment={area.id}
                            showLink={showLink}
        /> : ''}
    </div>
    : ''
}

export function widthToMaxWidth (width, theme) {
  let mapWidth = theme.breakpoints.values[width]
  if (mapWidth > 960) {
    mapWidth = 1240
  }
  return mapWidth
}

class ArticlePointMapSegment extends React.Component {
  state = {
    popoverOpen: false,
    anchorEl: null,
    area: null,
    lessonArea: null,
    lessonOpen: false,
    detailsOpen: false,
    // selectedId: null,
  }

  handleClick = (section, index, event) => {
    let child = this.props.child.children[index]

    let area = {
      id: child.id,
      name: child.button_label || child.name,
      item_type: child.item_type,
      activity: child.activity,
      area_type: section,
      segment_menu: child.segment_menu,
      // lesson
      content_before: child.f_lesson_content_before,
      // reflection
      content_after: child.f_lesson_content_after,
      content: child.formatted_content,
      activity_text: child.f_activity_text,
      activity_text_after: child.f_activity_text_after,
      details_title: child.details_title,
      formatted_blurb_details: child.formatted_blurb_details,
    }
    if (area.area_type === LESSON_ACTIVITY) {
      // tool
      this.setState({ lessonArea: area, area, lessonOpen: true })
      // this.scrollToMyRef()
    } else {
      this.setState({
        anchorEl: event.currentTarget,
        area
      })
    }
  }

  handleClose = () => {
    this.setState({
      anchorEl: null,
      area: null,
      lessonOpen: false,
      lessonArea: null
    })
  }
  handleCloseLesson = () => {
    this.setState({
      anchorEl: null,
      lessonOpen: false,
      area: null,
      lessonArea: null
    })
  }

  showDetails = () => {
    this.setState({ detailsOpen: true })
  }
  hideDetails = () => {
    this.setState({ detailsOpen: false })
  }

  render () {
    let {
      classes,
      // files,
      // directory,
      className,
      width,

      child,
      theme,
      article,
      // ...props
    } = this.props
    const { anchorEl, area, lessonOpen, lessonArea, detailsOpen } = this.state
    const open = Boolean(anchorEl)

    let segmentProps = JSON.parse(child.content)
    let drawerIcon, drawerTitle, drawerButton

    const mapWidth = widthToMaxWidth(width, theme)
    const imgWidth = segmentProps.imageWidth
    const imgHeight = segmentProps.imageHeight

    let arrowClass, drawerClass

    let lessonSegment = null
    let showLink = false
    if (lessonArea && lessonOpen) {
      switch (lessonArea.item_type) {
        case DRAG_NAMES:
          lessonSegment = <PyramidOfHateSegment area={lessonArea}/>
          break
        case MEMORY:
          lessonSegment = <SymbolsOfHateSegment area={lessonArea}/>
          break
        case POINTS_TO_QUESTIONS:
          lessonSegment = <PictureCutSegment area={lessonArea}/>
          break
        case ARTICLE_RELIABILITY:
          lessonSegment = <ArticleReliability area={lessonArea}/>
          break
        case CIRCLE_OF_HATE:
          lessonSegment = <CircleOfHateSegment area={lessonArea}/>
          break
        case GROUNDING:
          lessonSegment = <GroundingSubsegment area={lessonArea}/>
          break
        case BURDEN_TREE:
          lessonSegment = <BurdenTreeSegment area={lessonArea}/>
          break
        case ACTIVE_LISTENING:
          lessonSegment = <ActiveListeningSegment area={lessonArea}/>
          break
        case MIND_MAP:
          showLink = true
          lessonSegment = ''
          break
        default:
          lessonSegment = null

      }
    }
    arrowClass = classes.arrowSide
    drawerClass = classes.drawerPaper
    if (area) {
      switch (area.area_type) {
        case LESSON_ACTIVITY:
          drawerButton = 'Activity'
          drawerIcon = activityBlack
          arrowClass = classes.arrowSideActivity
          drawerClass = classes.drawerPaperActivity
          if (area.item_type === ARTICLE_RELIABILITY) {
            drawerClass = classes.drawerPaperActivityReliability
            arrowClass = classes.arrowSideActivityReliability
          } else if (area.item_type === DRAG_NAMES) {
            drawerClass = classes.drawerPaperActivityPyramid
            arrowClass = classes.arrowSideActivityPyramid
          }
          break
        case LESSON_REFLECTION:
          drawerButton = 'Reflection'
          drawerIcon = reflectionBlack
          break
        case LESSON_LESSON:
          drawerButton = 'Lesson'
          drawerIcon = lessonBlack
          break
        case CASE_STUDY:
          drawerButton = 'Info'
          drawerIcon = infoBlack
          break
        default:
          drawerButton = 'Info'
          drawerIcon = infoBlack
      }
      drawerTitle = area.name
    }
    console.log(article)

    return [<Paper key="image_mapper" className={className}>
      <div className={classes.pointsBackground}
           style={{ width: mapWidth, height: '100%' }}>
        <Typography className={classes.inSituTitle}>
          Searching relief in places of pain: in-situ and place-based remembrance education
        </Typography>

        {article && Boolean(article.formatted_blurb_details) &&
        <Button size="small" className={classes.cardLink} onClick={this.showDetails}>
          {article.details_title}
          <SvgArrowRed className={classes.arrowRight}/>
        </Button>
        }
        <Dialog open={detailsOpen}
                onClose={this.hideDetails}
                scroll='paper'
        >
          <DialogContent>
            {article && Boolean(article.formatted_blurb_details) &&
            <div dangerouslySetInnerHTML={{ __html: article.formatted_blurb_details }}></div>
            }
          </DialogContent>
        </Dialog>
        <ImagePoints
          // TODO use modified instead
          src={segmentProps.src + '?20191128'} map={child.children}
          width={mapWidth}
          imgWidth={imgWidth}
          imgHeight={imgHeight}
          lineWidth={0}
          strokeColor='rgba(0, 0, 0, 0)'
          onMouseMove={() => null}
          handleClick={(section, index, event) => {
            this.handleClick(section, index, event)
          }}
        />
        <HowToUse topics={child.children.map(item => item.button_label || item.name)}/>
      </div>
      <ContentDrawer open={open || lessonOpen}
                     onClose={this.handleClose}
                     classes={{ drawerPaper: drawerClass }}
      >
        <div className={classes.scrollIcon}>
          <SVGInline svg={scrollBlack} className={classes.helpIcon} height='70px' width='70px' fill={'#fff'}/>
        </div>
        {open || lessonOpen ?
          <div>
            <div className={classes.titleHeader}>
              <div className={classes.activityText}>
                {drawerIcon ?
                  <SVGInline svg={drawerIcon} className={classes.helpIcon} height='31px' width='31px' fill={'#fff'}/>
                  : ''}
                <Typography className={classes.rightTextInner}>
                  {drawerButton}
                </Typography>
              </div>
              <div className={classes.articleTitle}>
                {drawerTitle}
              </div>
              <div className={classes.articleTitleBorder}>
                &nbsp;
              </div>
            </div>
          </div>
          : ''}
        {open || lessonOpen ?
          <div className={classes.paper}>
            <SubsegmentElement area={area}/>
          </div>
          : ''}

        {lessonOpen ? [
          lessonArea.content_before && lessonArea.area_type === LESSON_LESSON ?
            <Paper key="lesson_before" id="lesson_before" className={classes.lessonBefore}>
              <Typography component='div'>
                <div dangerouslySetInnerHTML={{ __html: lessonArea.content_before }}></div>
              </Typography>
            </Paper> : '',
          lessonArea.activity_text && lessonArea.area_type === LESSON_ACTIVITY ?
            <Paper key="activity_text" id="activity_text" className={classes.lessonBefore}>
              <Typography component='div'>
                <div dangerouslySetInnerHTML={{ __html: lessonArea.activity_text }}></div>
              </Typography>
            </Paper> : '',
          lessonArea.area_type === LESSON_ACTIVITY ?
            <Paper key="lesson_content" className={classes.lessonContent}>
              {lessonSegment}
            </Paper> : '',
          lessonArea.activity_text_after && lessonArea.area_type === LESSON_ACTIVITY ?
            <Paper key="activity_text_after" className={classes.lessonBefore}>
              <Typography component='div'>
                <div dangerouslySetInnerHTML={{ __html: lessonArea.activity_text_after }}></div>
              </Typography>
            </Paper> : '',
          lessonArea.content_after && lessonArea.area_type === LESSON_REFLECTION ?
            <Paper key="lesson_after" className={classes.lessonAfter}>
              <Typography component='div'>
                <div dangerouslySetInnerHTML={{ __html: lessonArea.content_after }}></div>
              </Typography>
            </Paper>
            : '',
        ] : ''
        }
      </ContentDrawer>
      {open || lessonOpen ?
        <div className={arrowClass} onClick={() => this.handleClose()}>
          <SVGInline svg={arrowBlack} className={classes.helpIcon} height='90px' width='90px' fill={'#fff'}/>
        </div> : ''}
    </Paper>,
    ]
  }
}

export default withWidth()(
  withStyles(styles, { withTheme: true })(
    ArticlePointMapSegment
  ))
